import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, handleAxiosError, urlBackend } from "@/shared";
import { IDataSolicitudSupercion, IDataSolicitudSupercionParams, ISolicitudFallidoParams, ISolicitudSupervicion, ISolicitudSupervicionFallido, ISolicitudSupervicionParams, } from "@/shared/interfaces/erp/supervision/supervision.interface";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put } = erpApi();


///* Solicitud para crear una nueva liena
export const useGetFetchSupervision = (params?: IDataSolicitudSupercionParams) => {
  return useQuery({
    queryKey: ['solicitud-desbloqueo', ...Object.values(params || {})],
    queryFn: async () => {
      return getSupervicion(params);
    }
  });
}

export const getSupervicion = async (params?: IDataSolicitudSupercionParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<ISolicitudSupervicion>(`${urlBackend}api/v1/solicitud-desbloqueo/?${queryParams}`, true);
  return resp;
}

export const useFetchPutNuevaLinea = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({

    mutationFn: async (
      { id_solicitud_desbloqueo,
        params }: { id_solicitud_desbloqueo: string, params: IDataSolicitudSupercionParams }
    ) => {
      return putLiberarNuevaLinea(id_solicitud_desbloqueo, params);
    },
    onSuccess: (data) => {
      setAlert(true, data.message, data.status);

    },
    onError: (e) => {
      handleAxiosError(e)
    },
    onSettled: (_se) => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-desbloqueo'] });
    }
  })
}

export const putLiberarNuevaLinea = async (id_solicitud_desbloqueo: string, params: IDataSolicitudSupercionParams) => {
  const resp = await put<IDataSolicitudSupercion>(`${urlBackend}api/v1/solicitud-desbloqueo/${id_solicitud_desbloqueo}/`, params, true);
  return resp;
}

export const postSolicitudSupervicion = async (param: ISolicitudSupervicionParams) => {
  const resp = await post<IDataSolicitudSupercion>(`${urlBackend}api/v1/solicitud-desbloqueo/`, param, true);
  return resp;
}

export const postSolicitudFallido= async (param: ISolicitudFallidoParams) => {
  const resp = await post<IDataSolicitudSupercion>(`${urlBackend}api/v1/solicitud-fallido/`, param, true);
  return resp;
}

export const usePutFetchSolicitudSupervision = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({

    mutationFn: async ({ id, data }: {
      id: number;
      data: ISolicitudSupervicion;
    }) => {
      return putSolicitudSupervision(id, data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['solicitudes-supervisor'] });
      setAlert(true, data.message, data.status);

    }
  })
}

export const putSolicitudSupervision = async (idSolicitud: number, data?: ISolicitudSupervicion) => {
  const resp = await put<IDataSolicitudSupercion>(`${urlBackend}api/v1/solicitudes-supervisor/${idSolicitud}/`, data, true);
  return resp;
}

///* Solicitud liberar un prospecto
export const useGetFetchSupervisionLiberacionProspecto = (params?: ISolicitudFallidoParams) => {
  return useQuery({
    queryKey: ['solicitud-fallido', ...Object.values(params || {})],
    queryFn: async () => {
      return getSupervicionLiberacionProspecto(params);
    }
  });
}

export const getSupervicionLiberacionProspecto = async (params?: ISolicitudFallidoParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<ISolicitudSupervicionFallido>(`${urlBackend}api/v1/solicitud-fallido/?${queryParams}`, true);
  return resp;
}

export const useFetchLiberarProspecto = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({

    mutationFn: async (
      { id_solicitud_desbloqueo,
        params }: { id_solicitud_desbloqueo: string, params: IDataSolicitudSupercionParams }
    ) => {
      return putLiberarProspecto(id_solicitud_desbloqueo, params);
    },
    onSuccess: (data) => {
      setAlert(true, data.message, data.status);

    },
    onError: (e) => {
      handleAxiosError(e)
    },
    onSettled: (_se) => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-fallido'] });
    }
  })
}

export const putLiberarProspecto = async (id_solicitud_desbloqueo: string, params: IDataSolicitudSupercionParams) => {
  const resp = await put<IDataSolicitudSupercion>(`${urlBackend}api/v1/solicitud-fallido/${id_solicitud_desbloqueo}/`, params, true);
  return resp;
}